// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inv-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, .45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.inv-modal {
  width: min(520px, calc(100% - 32px));
  background: #fff;
  /* border-radius: 12px; */
  padding: 18px 18px 14px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, .25);
}

.inv-modal-title {
  font-size: 17px;
  font-weight: 500;
  margin-bottom: 40px;
}

.inv-modal-desc {
  font-size: 16px;
  margin-bottom: 16px;
}

.inv-modal-actions1 {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}

.inv-modal-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 16px;
}

.inv-modal-actions-left,
.inv-modal-actions-right {
  display: flex;
  gap: 10px;
}

.inv-btn {
  padding: 10px 14px;
  border-radius: 10px;
  border: 1px solid #ddd;
  background: #fff;
  cursor: pointer;
}

.inv-btn-primary {
  border-color: transparent;
  background: #2d6cdf;
  color: #fff;
}

.inv-btn:disabled {
  opacity: .6;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/web/component/DialogWindow/styles.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB","sourcesContent":[".inv-modal-overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(0, 0, 0, .45);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 9999;\r\n}\r\n\r\n.inv-modal {\r\n  width: min(520px, calc(100% - 32px));\r\n  background: #fff;\r\n  /* border-radius: 12px; */\r\n  padding: 18px 18px 14px;\r\n  box-shadow: 0 10px 30px rgba(0, 0, 0, .25);\r\n}\r\n\r\n.inv-modal-title {\r\n  font-size: 17px;\r\n  font-weight: 500;\r\n  margin-bottom: 40px;\r\n}\r\n\r\n.inv-modal-desc {\r\n  font-size: 16px;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.inv-modal-actions1 {\r\n  display: flex;\r\n  gap: 10px;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.inv-modal-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-top: 16px;\r\n}\r\n\r\n.inv-modal-actions-left,\r\n.inv-modal-actions-right {\r\n  display: flex;\r\n  gap: 10px;\r\n}\r\n\r\n.inv-btn {\r\n  padding: 10px 14px;\r\n  border-radius: 10px;\r\n  border: 1px solid #ddd;\r\n  background: #fff;\r\n  cursor: pointer;\r\n}\r\n\r\n.inv-btn-primary {\r\n  border-color: transparent;\r\n  background: #2d6cdf;\r\n  color: #fff;\r\n}\r\n\r\n.inv-btn:disabled {\r\n  opacity: .6;\r\n  cursor: not-allowed;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
